module.exports = __webpack_public_path__ + "static/media/help.a3807516.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help.svg
// module id = 1982
// module chunks = 0